module.exports = __webpack_public_path__ + "static/avatar-4bb03784e65d8597dea5c38b6a6436bc.jpg";